import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SettingsService } from '@app/core/settings/services/settings.service';

@Component({
  selector: 'filter-product-dept',
  templateUrl: './filter-product-dept.component.html',
  styleUrls: ['./filter-product-dept.component.scss'],
})
export class FilterProductDeptComponent implements OnInit {
  constructor(public settingsSvc :SettingsService) {}

  @Input() value :number;
  @Input() label :string;
  @Output() selectChange :EventEmitter<number> = new EventEmitter<number>();

  ngOnInit() :void {}

  onChange(event :any) {
    this.selectChange.emit(parseInt(event.target.value, 10));
  }
}
